/*
 * Saraj entrance motion. Pairs with the "Motion" rules in saraj-brand.css,
 * which only apply while <html> has .saraj-motion.
 */
(() => {
  const root = document.documentElement;
  if (!root.classList.contains('saraj-motion')) return;

  const IMAGE_WAIT_MS = 1200;

  /** Resolves when the hero's visible photo can paint, or after IMAGE_WAIT_MS. */
  const photoReady = (hero) => {
    const image = [...hero.querySelectorAll('img.hero__media')].find((img) => img.offsetParent !== null);
    if (!image || image.complete) return Promise.resolve();

    const loaded = new Promise((resolve) => {
      image.addEventListener('load', resolve, { once: true });
      image.addEventListener('error', resolve, { once: true });
    });
    const timeout = new Promise((resolve) => setTimeout(resolve, IMAGE_WAIT_MS));
    return Promise.race([loaded, timeout]);
  };

  const revealHeroes = () => {
    const heroes = document.querySelectorAll('.hero');
    if (!heroes.length) {
      root.classList.add('saraj-hero-in');
      return;
    }

    heroes.forEach((hero, index) => {
      photoReady(hero).then(() => {
        requestAnimationFrame(() => {
          hero.classList.add('is-revealed');
          if (index === 0) root.classList.add('saraj-hero-in');
        });
      });
    });
  };

  const revealSectionsOnScroll = () => {
    const sections = document.querySelectorAll('#MainContent > .shopify-section:not(.hero-wrapper)');
    if (!('IntersectionObserver' in window)) {
      sections.forEach((section) => section.classList.add('is-inview'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-inview');
          observer.unobserve(entry.target);
        });
      },
      // threshold 0: reveal as soon as the top edge is in view, however tall the section
      { rootMargin: '0px 0px -8% 0px', threshold: 0 }
    );
    sections.forEach((section) => observer.observe(section));
  };

  const start = () => {
    root.classList.add('saraj-motion-ready');
    revealHeroes();
    revealSectionsOnScroll();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
